import { render } from "./HotelBookingBanner.vue?vue&type=template&id=2cd3e298"
import script from "./HotelBookingBanner.vue?vue&type=script&lang=js"
export * from "./HotelBookingBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__